/* Perf: plays <video data-lazy-video> only when near the viewport (see snippets/lazy-video.liquid). */
(function () {
  if (window.__lazyVideoInit) return;
  window.__lazyVideoInit = true;

  function play(video) {
    video.muted = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      var autoplay = video.hasAttribute('data-autoplay');
      if (entry.isIntersecting) {
        if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
        if (autoplay) play(video);
        else if (video.preload === 'none') video.preload = 'metadata';
      } else if (autoplay && !video.paused) {
        video.pause();
      }
    });
  }

  function init() {
    var videos = document.querySelectorAll('video[data-lazy-video]:not([data-lazy-bound])');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        video.setAttribute('data-lazy-bound', '');
        if (video.dataset.poster) video.poster = video.dataset.poster;
        if (video.hasAttribute('data-autoplay')) play(video);
      });
      return;
    }

    window.__lazyVideoObserver =
      window.__lazyVideoObserver || new IntersectionObserver(onIntersect, { rootMargin: '400px 0px' });
    videos.forEach(function (video) {
      video.setAttribute('data-lazy-bound', '');
      window.__lazyVideoObserver.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
